import { Nullable } from 'common-types';
import { createStore } from 'store-utils';

const EmailVerificationStore = createStore<EmailVerificationStoreState>(
  {
    isLoading: false,
    emailVerificationError: null,
  },
  'Email Verification Store',
);

interface EmailVerificationStoreState {
  isLoading: boolean;
  emailVerificationError: Nullable<string>;
}

export default EmailVerificationStore;
